import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { RefService } from '../api/RefService';
import { LinnaeService } from '../api/LinnaeService';
import { FileStore, FileData, TaxaSearchStore, TaxaValidStore, ValidTaxa, Taxons, TaxonStatusStore, StatusTaxonResponse, RefVersionStore } from '../models/types';
import { RefStore } from '@front-ends/common/src/utils/types/RefTypes';
import { TerrUnitStore } from '@front-ends/common/src/utils/types/TerrUnitTypes';
import { TxRef } from '@front-ends/common/src/utils/types/RefTypes';

export const StoreRef = create(persist<RefStore>(
    (set) => ({
        isLoading: false,
        isFinished: false,
        errorRef: '',
        search: async () => {
            try {
                set({ isLoading: false, isFinished: false});
                const data:Array<{ key: string; name: string;ordre:number;terrUnitKey: string;ref:string}> = await RefService.getAllRefType();
                set(() =>({ isLoading: false, response:data, isFinished: false }));
            }   catch (err: any) {
                const errorRef =
                err?.message || err?.data?.message || 'StoreRef : Unexpected network error.';
                set(() => ({ 
                    isLoading: false,
                    errorRef,
                    isFinished: false
                }));
            }
        },
    }),
    {
        name: 'ref-store',
        storage: createJSONStorage(() => localStorage),
    },
));

export const StoreTerrUnit = create(persist<TerrUnitStore>(
    (set) => ({
        isLoading: false,
        isFinished: true,
        error: '',
        response: [],
        search:  async (value:string) => {
            try {
                set({ isLoading: true, isFinished: false});
                const data:Array<{ key: string; name: string;ordre:number;terrUnitKey: string;ref:string,level:number}> = await RefService.getTerrUnits(value);                
                set(() =>({ isLoading: false, response:data ,isFinished: true}));
            }   catch (err: any) {
                const errorTerrUnit = 
                err?.message || err?.data?.message || 'StoreTerrUnit : Unexpected network error.';
                set(() => ({
                isLoading: false,
                errorTerrUnit,
                isFinished: false }));
            }
        },
    }),
    {
        name: 'terr-unit-store',
        storage: createJSONStorage(() => localStorage),
    },
));

export const StoreFile = create(persist<FileStore>(
    (set) => ({
        isFinished: false,
        isLoading: false,
        response: [],
        upload: async (formdata:FormData, importType:string) => {
            try {
                set({isLoading: true});
                const data:Array<FileData> = await LinnaeService.postFile(formdata, importType);
                set(() =>({ isLoading: false, response:data, isFinished: true }));
            }   catch (err: any) {
                const errorFile =
                err?.message || err?.data?.message || 'StoreFile : Unexpected network error.';
                set(() => ({ 
                    errorFile,
                    isFinished: false
                }));
            }
        },
    }),
    {
        name: 'file-store',
        storage: createJSONStorage(() => localStorage),
    },
));

export const StoreTaxaName = create(persist<TaxaSearchStore>(
    (set) => ({
        isLoading: false,
        isFinished: false,
        response:<Taxons>{},
        search:  async (value:string, version:string, ref:string, filter:string) => {
            try {
                set({ isLoading: true, isFinished: false});
                const data:Taxons = await RefService.getTaxaName(value, version, ref, filter);                
                set(() =>({ isLoading: false, response:data ,isFinished: true}));
            }   catch (err: any) {
                const errorTaxaName = 
                err?.message || err?.data?.message || 'StoreTaxaName : Unexpected network error.';
              set(() => ({
                isLoading: false,
                errorTaxaName,
                isFinished: false
            }));
            }
        },
    }),
    {
        name: 'taxa-name-store',
        storage: createJSONStorage(() => localStorage),
    },
));

export const StoreValidTaxa = create(persist<TaxaValidStore>(
    (set) => ({
        isLoading: false,
        isFinished: false,
        validNameResponse: <ValidTaxa>{},
        find:  async (key:string, version:string, ref:string, filter:string) => {
            try {
                set({ isLoading: true, isFinished: false});
                const data:ValidTaxa = await RefService.getTaxaDetails(key, version, ref, filter);      
                set(() =>({ isLoading: false, validNameResponse:data ,isFinished: true}));
            }   catch (err: any) {
                const errorTaxaSynonym = 
                err?.message || err?.data?.message || 'StoreValidTaxa : Unexpected network error.';
              set(() => ({
                isLoading: false,
                errorTaxaSynonym,
                isFinished: false
            }));
            }
        },
    }),
    {
        name: 'taxa-synonym-store',
        storage: createJSONStorage(() => localStorage),
    },
));

export const StoreRefVersion = create(persist<RefVersionStore>(
    (set) => ({
        isLoading: false,
        isFinished: false,
        refResult: <TxRef>{},
        find:  async (ref: string) => {
            try {
                set({ isLoading: true, isFinished: false});
                const data = await RefService.getRefVersion(ref);                
                set(() =>({isLoading: false, refResult:data, isFinished: true}));
            }   catch (err: any) {
                const errorRefVersion = 
                err?.message || err?.data?.message || 'StoreRefVersion : Unexpected network error.';
              set(() => ({
                isLoading: false,
                errorRefVersion,
                isFinished: false
            }));
            }
        },
    }),
    {
        name: 'ref-version-store',
        storage: createJSONStorage(() => localStorage),
    },
));

export const StoreStatus = create(persist<TaxonStatusStore>(
    (set) => ({
        isLoading: false,
        isFinished: false,
        response: [],
        upload:  async (formdata:FormData) => {
            try {
                set({ isLoading: true});
                const data: Array<StatusTaxonResponse> = await LinnaeService.postConsolidation(formdata);
                set(() =>({ isLoading: false, response: data, isFinished: true }));
            }   catch (err: any) {
                const errorStatus = 
                err?.message || err?.data?.message || 'StoreStatus : Unexpected network error.';
              set(() => ({
                isLoading: false,
                errorStatus,
                isFinished: false }));
            }
        },
    }),
    {
        name: 'taxa-status-store',
        storage: createJSONStorage(() => localStorage),
    },
));